export const cleanRoutePath = (path = '') => {
  return path?.replace(/\/:\w+/g, '');
};
